<div class="action-form">
  <span class="title">{{ 'CONTACT_BALANCE_TRANSACTION.MOVE_HEADER' | translate }}</span>
  <div class="desc">{{ 'CONTACT_BALANCE_TRANSACTION.MOVE_DESCRIPTION' | translate }}</div>
  @if (forms) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      @for (cform of $any(forms.controls); track cform; let i = $index) {
        <div class="row form-group">
          <div class="col-12">
            <h6>{{ cform.controls['companyCaption'].value }}</h6>
          </div>
          <div class="col-12 col-sm-6">
            <app-money-box [control]="cform.controls['amount']"></app-money-box>
          </div>
          <div class="col-12 col-sm-6">
            <app-autocomplete-remote
              [control]="cform.controls['contactId']"
              [service]="filterService"
              (itemSelected)="onContactSelected($event, cform.controls['contactId'], cform.controls['companyId'].value)"
              >
            </app-autocomplete-remote>
          </div>
        </div>
      }
      <div class="row form-group">
        <div class="col-12">
          <button class="btn btn-active" type="submit" [disabled]="okButtonDisabled">{{ 'OK_BTN' | translate }}</button>
          <button class="btn link-btn ml-2" (click)="cancel()">{{ 'CANCEL_BTN' | translate }}</button>
        </div>
      </div>
    </form>
  }
</div>
